/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import { makeData } from 'core/types/makeData'

import * as ApiVersioningTypes from './types'

export type ApiVersionsGetAllKey = ['api-versions', unknown]

export type ApiVersionsGetAllResponse = {
  data?: Array<ApiVersioningTypes.ResponseAPIVersions>
}

export type ApiVersionsGetAllVariables = {
  body?: void
  query?: void
}

export const apiVersionsGetAll = makeData<ApiVersionsGetAllResponse, ApiVersionsGetAllKey, ApiVersionsGetAllVariables>({
  method: 'get',
  name: 'apiVersionsGetAll',
  summary: 'Get API versions',
  path: '/api-versions',
  queryKey: ({ query }) => ['api-versions', query],
})
